import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomTable from "../../../../components/custom-table/custom-table";
import { useDataAccumulatorForSingleOrder } from "../../../../context/dataAccumulatorForSingleOrder";
import { RootState } from "../../../../redux/store/store";
import { cptTableHeader, createCptCodesTableData } from "./cptCodesTable";

/**
 * Renders the CPT/J-code table on the submission status screen, sourcing auth
 * entries and the order-created timestamp from the Postgres data accumulator.
 *
 * @returns The CPT codes table section.
 */
const CptComponentCodes = () => {
  const [data, setData] = useState<any[]>([]);
  const { authOnFileDetails, generalOrderDetails } =
    useDataAccumulatorForSingleOrder();
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  const authOnFile = authOnFileDetails?.auth_on_file;
  const orderCreatedAt =
    generalOrderDetails?.order?.timestamps?.order_created_at;
  useEffect(() => {
    if (authOnFile && authStatusOptions) {
      setData(
        createCptCodesTableData(
          authOnFile,
          orderCreatedAt,
          authStatusOptions ?? [],
        ),
      );
    }
  }, [authOnFile, orderCreatedAt, authStatusOptions]);
  return (
    <>
      <div className="cpt-codes--container flex flex-col gap-2">
        <div className="cpt-codes--header text-small font-bold leading-5">
          CPT Codes
        </div>
        <div className="cpt-codes--table">
          <CustomTable
            tableHeaders={cptTableHeader}
            hideSearchBar={true}
            count={data?.length}
            tableData={data}
            itemsPerPage={20}
            pagesPerView={3}
            hidePagination={true}
            tableName="cpt-codes"
          />
        </div>
      </div>
    </>
  );
};

export default CptComponentCodes;
